<template>
  <div class="box">
    <el-drawer
      :visible.sync="visible"
      :wrapperClosable="false"
      :show-close="false"
      :close-on-press-escape="false"
      custom-class="drawer1"
      :size="size"
    >
      <div slot="title" style="border-bottom:1px solid #ccc;padding-bottom:10px;">
        “
        <span style="color:red">{{title.user_name}}</span>
        ” 在 “
        <span style="color:red">{{title.project_name}}</span>
        ” 的回访记录信息
      </div>

      <el-card>
        <WtDataTable
          ref="tables"
          :listUrl="$db.config.cf_project.apply.visit_list"
          :urlParams="{apply_id:id}"
        >
          <div slot="buttons">
            <el-button
              size="small"
              style="margin:10px 0px"
              icon="el-icon-plus"
              type="primary"
              @click="doVisit"
            >新增回访记录</el-button>
          </div>
          <template slot="columns">
            <el-table-column prop="visit_user" label="回访人" align="center" min-width="250"></el-table-column>
            <el-table-column prop="visit_time" label="回访日期" align="center" width="120"></el-table-column>
            <el-table-column label="操作" align="center" width="200" fixed="right">
              <template slot-scope="scope">
                <el-button-group>
                  <el-button
                    type="primary"
                    icon="el-icon-view"
                    size="mini"
                    @click="showDetail(scope.row)"
                  >查看</el-button>
                </el-button-group>
              </template>
            </el-table-column>
          </template>
        </WtDataTable>
      </el-card>

      <div class="demo-drawer-footer">
        <el-button type="danger" size="small" icon="el-icon-close" @click="close">关闭</el-button>
      </div>

      <!-- <el-dialog title="回访记录" :visible.sync="detailModal" :append-to-body="true" width="65%">
        
      </el-dialog>-->

      <el-dialog
        :title="if_detail?'查看回访记录':'新增回访记录'"
        :visible.sync="visitModal"
        :append-to-body="true"
        width="65%"
      >
        <el-form
          :model="visitForm"
          label-width="80px"
          :rules="rules"
          ref="formRef"
          :disabled="if_detail"
        >
          <el-form-item label="回访人" prop="visit_user">
            <el-input v-model="visitForm.visit_user" style="width:40%" size="small"></el-input>
          </el-form-item>

          <el-form-item label="回访日期" prop="visit_time">
            <el-date-picker
              v-model="visitForm.visit_time"
              type="date"
              size="small"
              value-format="yyyy-MM-dd"
              placeholder="请选择回访日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="回访记录" required>
            <el-card>
              <div v-for="(item,index) in questionList" :key="index">
                <p>
                  <span style="color:red">问：</span>
                  {{item.question_name}}
                </p>
                <div v-if="item.option_type == 2">
                  <span style="color:green">答：</span>
                  <el-input
                    v-model="questionList[index].option_item"
                    style="width:80%"
                    size="small"
                  ></el-input>
                </div>
                <div v-else>
                  <span style="color:green">答：</span>
                  <template v-for="(val,key) in item.option_item">
                    <!-- <el-radio :key="'answer'+key" v-model="questionList[index].option_item[key].check" :label="val.id" border size="medium">{{val.value}}</el-radio> -->
                    <el-checkbox
                      :key="'answer'+key"
                      v-model="questionList[index].option_item[key].check"
                      :label="val.value"
                      border
                      @change="changeBox($event,index,key)"
                      size="medium"
                    ></el-checkbox>

                    <el-input
                      v-if="val.input != undefined && val.check"
                      v-model="questionList[index].option_item[key].input"
                      style="width:210px"
                      placeholder="请输入其他"
                      size="small"
                    ></el-input>
                  </template>
                </div>
              </div>
            </el-card>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="danger" size="small" icon="el-icon-close" @click="cancelBtn">关闭</el-button>
          <el-button
            type="primary"
            size="small"
            v-if="!if_detail"
            icon="el-icon-check"
            @click="submitBtn"
            :loading="loading"
          >提交</el-button>
        </div>
      </el-dialog>
    </el-drawer>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: Object,
      default: () => {}
    },
    size: {
      type: [String, Number],
      default: "85%"
    },
    id: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      search: {},
      visible: false,
      loading: false,

      if_detail: false,

      visitModal: false, //新增回访
      visitForm: {
        visit_user: null,
        visit_time: null,
        answer: []
      },
      rules: {
        visit_user: [
          { required: true, message: "回访人不能为空！", trigger: "blur" }
        ],
        visit_time: [
          { required: true, message: "回访日期不能为空！", trigger: "change" }
        ]
      },

      questionList: [] //
    };
  },
  methods: {
    close() {
      this.visible = false;
    },

    changeBox(val, index, key) {
      this.questionList[index].option_item.forEach((r, i) => {
        if (val && i == key) {
          r.check = true;
        } else {
          r.check = false;
        }
      });
    },

    //查看回访详情
    showDetail(row) {
      this.if_detail = true;
      this.$db
        .post(this.$db.config.cf_project.apply.visit_info, { id: row.id })
        .then(res => {
          if (res && res.code == 200) {
            this.visitForm.visit_user = res.data.visit_user;
            this.visitForm.visit_time = res.data.visit_time;
            this.questionList = res.data.answer;
            this.visitModal = true;
          }
        });
    },

    //新增回访记录
    doVisit() {
      this.if_detail = false;
      this.visitModal = true;
      this.getQuestionList();
    },

    cancelBtn() {
      this.visitForm.visit_user = null;
      this.visitForm.visit_time = null;
      this.visitForm.answer = [];
      this.visitModal = false;
    },

    submitBtn() {
      this.visitForm.answer = this.questionList;
      this.visitForm.apply_id = this.id;
      this.loading = true;
      this.$refs["formRef"].validate(valid => {
        if (valid) {
          this.$db
            .post(this.$db.config.cf_project.apply.visit_add, this.visitForm)
            .then(res => {
              if (res && res.code == 200) {
                this.$message.success(res.msg);
                this.cancelBtn();
                this.$refs.tables.reloadData();
              }
            });
        } else {
          this.loading = false;
          return this.$message.warning("请填写完整的表单信息！");
        }
      });
    },

    getQuestionList() {
      this.$db
        .post(this.$db.config.cf_project.apply.visit_question, {
          apply_id: this.id
        })
        .then(res => {
          if (res && res.code == 200) {
            this.questionList = res.data;
          }
        });
    }
  },
  watch: {
    visible(val) {
      this.$emit("input", val);
    },

    value: {
      handler(val) {
        this.visible = val;
      },
      immediate: true
    }
  },
  created() {
    // this.getDetail(this.id)
  }
};
</script>
<style lang="scss" scoped>
.box /deep/ .drawer1 {
  overflow: auto;
}
.demo-drawer-footer {
  width: 85%;
  position: fixed;
  bottom: 0;
  right: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/Hospital/cfproject/apply/visit_list.vue